import { api } from "../../../api/apiSlice";

// Legacy HR job-title master (Designation_Master) - NOT the RBAC
// designations under Administration. See handoff §9.2.
export const hrDesignationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHrDesignations: builder.query({
      query: () => ({ url: "/masters/designations" }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((d) => ({ type: "HrDesignations", id: d.designationCode })),
              { type: "HrDesignations", id: "LIST" },
            ]
          : [{ type: "HrDesignations", id: "LIST" }],
    }),
    createHrDesignation: builder.mutation({
      query: (body) => ({ url: "/masters/designations", method: "POST", data: body }),
      invalidatesTags: [{ type: "HrDesignations", id: "LIST" }],
    }),
    updateHrDesignation: builder.mutation({
      query: ({ code, ...body }) => ({
        url: `/masters/designations/${code}`,
        method: "PUT",
        data: body,
      }),
      invalidatesTags: [{ type: "HrDesignations", id: "LIST" }],
    }),
    deleteHrDesignation: builder.mutation({
      query: (code) => ({ url: `/masters/designations/${code}`, method: "DELETE" }),
      invalidatesTags: [{ type: "HrDesignations", id: "LIST" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetHrDesignationsQuery,
  useCreateHrDesignationMutation,
  useUpdateHrDesignationMutation,
  useDeleteHrDesignationMutation,
} = hrDesignationsApi;
